import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const whitfieldEstatesConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Whitfield Estates Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Whitfield Estates, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_whitfield_estates',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Whitfield Estates',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Whitfield Estates Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we understand the character and pride that 
     residents of <strong>Whitfield Estates</strong> put into their properties. Mature, 
     established trees are a big part of what makes this community beautiful but they 
     also require professional care to remain safe. Large overhanging limbs, aging canopies, 
     and trees stressed by Florida's storm season all need expert attention before they 
     become a problem.`,

    `We specialize in <strong>hazardous tree situations unique to established neighborhoods</strong>
     large canopy overhangs near homes and driveways, trees with structural cracks or 
     internal decay, storm damaged limbs, and dense growth that needs thinning to reduce 
     wind resistance. We handle every job with care for your landscape and your neighbors.`,

    `<strong>Sam's Tree Service</strong> brings trusted, professional tree care to 
     <strong>Whitfield Estates</strong> and the surrounding <strong>Manatee and Sarasota 
     County</strong> areas protecting the beauty and safety of your property through 
     every season.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Whitfield Estates, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_WhitfieldEstates = () => <LocationPage config={whitfieldEstatesConfig} />;
export default Services_WhitfieldEstates;
